/// <amd-module name="Repos/Tfvc/Views/ChangesetDetails/ChangesetDiscussionIntegrationService" />
import {
    ArtifactDiscussionIntegrationService,
    IArtifactDiscussionIntegrationService
} from "Repos/Artifact/Discussion/ArtifactDiscussionIntegrationService";
import { IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { getMarkdownEditorProps } from "Repos/Artifact/Discussion/CommonMarkdownProps";
import { IDiscussionMarkdownEditorProps } from "Repos/Discussion/DiscussionThread.Types";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { getDiscussionThreadService } from "./ChangesetDiscussionThreadService";

export interface IChangesetDiscussionIntegrationService extends IArtifactDiscussionIntegrationService {}

class ChangesetDiscussionIntegrationService extends ArtifactDiscussionIntegrationService implements IChangesetDiscussionIntegrationService {
    protected getDiscussionStore(pageContext: IVssPageContext): IArtifactDiscussionThreadService {
        return getDiscussionThreadService(pageContext);
    }

    protected getMarkdownEditorProps(): IDiscussionMarkdownEditorProps {
        return getMarkdownEditorProps("ms.vss-code-web.changeset-detail-markdown-commands");
    }
}

const serviceName = "IChangesetDiscussionIntegrationService";
export function getDiscussionIntegrationService(pageContext: IVssPageContext): IChangesetDiscussionIntegrationService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ChangesetDiscussionIntegrationService });
